export default defineNuxtRouteMiddleware(async (to) => {

  if (process.server) return

  const { isAuthenticated, getToken, getCurrentUser } = useAuthStorage()
  const config = useRuntimeConfig()

  const publicRoutes = [
    '/authenticate',
    '/erro-token',
  ]

  const isPublicRoute = publicRoutes.some(route => to.path.startsWith(route))

  if (isPublicRoute) {
    return
  }

  if (!isAuthenticated()) {

    const externalAuthURL = config.public.baseControleProcesssoURL
    if (externalAuthURL) {
      return navigateTo(externalAuthURL, { external: true })
    }

    return navigateTo('/authenticate')
  }

  try {

    if (!getCurrentUser()) {
      const { clearAuthData } = useAuthStorage()
      clearAuthData()

      const externalAuthURL = config.public.baseControleProcesssoURL
      if (externalAuthURL) {
        return navigateTo(externalAuthURL, { external: true })
      }
      return navigateTo('/authenticate')
    }

  } catch (error) {
    console.error('Auth middleware error:', error)

    const { clearAuthData } = useAuthStorage()
    clearAuthData()

    const externalAuthURL = config.public.baseControleProcesssoURL
    if (externalAuthURL) {
      return navigateTo(externalAuthURL, { external: true })
    }
    return navigateTo('/authenticate')
  }
}) 